// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-dialog {
  min-height: 20rem;
  min-width: 25rem;
}
.settings-dialog .form {
  min-height: 100%;
  min-width: 100%;
  margin-bottom: 1rem;
  background-color: var(--dialog-background-color);
  color: var(--dialog-foreground-color);
}
.settings-dialog .drawer {
  width: 80%;
}
.settings-dialog .related {
  height: 0;
}
.settings-dialog .padding {
  padding-left: 1rem;
}
.settings-dialog .line-settings {
  margin-right: 1rem;
}
.settings-dialog .min-max {
  width: 5rem;
}
.settings-dialog .time-horizon {
  width: -moz-fit-content;
  width: fit-content;
  padding-left: 1rem;
}
.settings-dialog .time-duration {
  width: 4rem;
  padding-left: 1rem;
}
.settings-dialog .edit-virtual-scroll {
  min-height: 15rem;
  width: 100%;
}
.settings-dialog .edit-virtual-scroll .mat-header-cell {
  font-size: 16px;
  font-weight: bold;
}
.settings-dialog .edit-virtual-scroll .mat-header-row {
  min-height: 2rem;
}
.settings-dialog .edit-virtual-scroll .mat-cell {
  font-size: 14px;
  width: auto;
  text-align: left;
}
.settings-dialog .edit-virtual-scroll .mat-row {
  min-height: 2rem;
}
.settings-dialog .search-row {
  display: flex;
  align-items: center;
}
.settings-dialog .search-row .show-all {
  margin-left: auto;
}
.settings-dialog .font-size {
  width: 4rem;
}
.settings-dialog .title {
  width: 20rem;
}

.flex-top-row {
  display: flex;
  flex-direction: row;
}
.flex-top-row .edit-icon {
  background-color: inherit;
  border: none;
}
.flex-top-row .view-title {
  flex-grow: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/widgets/dtc-widget/dtc-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,gBAAA;AACF;AACE;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gDAAA;EACA,qCAAA;AACJ;AAEE;EACE,UAAA;AAAJ;AAGE;EACE,SAAA;AADJ;AAIE;EACE,kBAAA;AAFJ;AAKE;EACE,kBAAA;AAHJ;AAME;EACE,WAAA;AAJJ;AAOE;EACE,uBAAA;EAAA,kBAAA;EACA,kBAAA;AALJ;AAQE;EACE,WAAA;EACA,kBAAA;AANJ;AASE;EACE,iBAAA;EACA,WAAA;AAPJ;AASI;EACE,eAAA;EACA,iBAAA;AAPN;AAUI;EACE,gBAAA;AARN;AAWI;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AATN;AAYI;EACE,gBAAA;AAVN;AAcE;EACE,aAAA;EACA,mBAAA;AAZJ;AAcI;EACE,iBAAA;AAZN;AAgBE;EACE,WAAA;AAdJ;AAiBE;EACE,YAAA;AAfJ;;AAqBA;EACE,aAAA;EACA,mBAAA;AAlBF;AAoBE;EACE,yBAAA;EACA,YAAA;AAlBJ;AAqBE;EACE,YAAA;AAnBJ","sourcesContent":[".settings-dialog {\n  min-height: 20rem;\n  min-width: 25rem;\n\n  .form {\n    min-height: 100%;\n    min-width: 100%;\n    margin-bottom: 1rem;\n    background-color: var(--dialog-background-color);\n    color: var(--dialog-foreground-color);\n  }\n\n  .drawer {\n    width: 80%;\n  }\n\n  .related {\n    height: 0;\n  }\n\n  .padding {\n    padding-left: 1rem;\n  }\n\n  .line-settings {\n    margin-right: 1rem;\n  }\n\n  .min-max {\n    width: 5rem;\n  }\n\n  .time-horizon {\n    width: fit-content;\n    padding-left: 1rem;\n  }\n\n  .time-duration {\n    width: 4rem;\n    padding-left: 1rem;\n  }\n\n  .edit-virtual-scroll {\n    min-height: 15rem;\n    width: 100%;\n\n    .mat-header-cell {\n      font-size: 16px;\n      font-weight: bold;\n    }\n\n    .mat-header-row {\n      min-height: 2rem;\n    }\n\n    .mat-cell {\n      font-size: 14px;\n      width: auto;\n      text-align: left;\n    }\n\n    .mat-row {\n      min-height: 2rem;\n    }\n  }\n\n  .search-row {\n    display: flex;\n    align-items: center;\n\n    .show-all {\n      margin-left: auto;\n    }\n  }\n\n  .font-size {\n    width: 4rem;\n  }\n\n  .title {\n    width: 20rem;\n  }\n\n}\n\n\n.flex-top-row {\n  display: flex;\n  flex-direction: row;\n\n  .edit-icon {\n    background-color: inherit;\n    border: none;\n  }\n\n  .view-title {\n    flex-grow: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
